import React, { useState } from 'react';
import { Form, Formik } from 'formik';

import { createFormValidationFn, createInitialValues } from 'client/helpers/formikHelpers';

import AuthActions from 'client/actions/UtilityAuth';

import SrFormikField from 'client/components/SrFormikField';
import useDispatch from 'client/hooks/useDispatch';
import SrLink from 'client/components/SrLink/SrLink';
import SrErrorMessage from 'client/components/SrErrorMessage/SrErrorMessage';
import { UTILITY_LOGIN_PROVIDER_PARTNER_FORM } from 'common/utility/constants';

const formFields = [
  {
    id: 'phone',
    type: 'phone',
    properties: {
      placeholder: 'Phone Number',
    },
    validations: ['phone', 'required'],
  },
  {
    id: 'password',
    type: 'password',
    properties: {
      autoComplete: 'false',
      placeholder: 'Password',
    },
    validations: ['required'],
  },
];

const SrUtilityPartnerLoginForm = ({ location }) => {
  const [submitError, setSubmitError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();

  const _onSubmit = (formValues) => {
    setIsSubmitting(true);
    setSubmitError('');
    dispatch(AuthActions.login, {
      ...formValues,
      provider: UTILITY_LOGIN_PROVIDER_PARTNER_FORM,
    })
      .then(() => {
        setIsSubmitting(false);
        setSubmitError('');
      })
      .catch((error) => {
        setIsSubmitting(false);
        setSubmitError(error.message);
      });
  };

  return (
    <Formik
      enableReinitialize
      validateOnChange={false}
      onSubmit={_onSubmit}
      initialValues={createInitialValues({
        formFields: formFields,
      })}
      validate={createFormValidationFn(formFields)}
      render={(formikBag) => {
        return (
          <>
            <div className="loginFormContainer">
              <Form>
                {submitError && <SrErrorMessage>{submitError}</SrErrorMessage>}
                {formFields.map((formField) => (
                  <SrFormikField key={formField.id} formField={formField} formikBag={formikBag} />
                ))}
                <button type="submit" className="button green-utility" disabled={isSubmitting}>
                  {isSubmitting ? 'logging in...' : 'log in'}
                </button>
              </Form>
              <div className="divisorContainer">
                <span className="signupLoginOrLabel">or</span>
              </div>
              <SrLink
                to="/utility-profit/signup"
                className="button yellow"
                name="createAccountButton"
              >
                create new account
              </SrLink>
              <SrLink
                to={`/utility-profit/reset-password${location.search}`}
                className="resetPassword"
              >
                Forgot Password?
              </SrLink>
            </div>
          </>
        );
      }}
    />
  );
};

SrUtilityPartnerLoginForm.displayName = 'SrUtilityPartnerLoginForm';

export default SrUtilityPartnerLoginForm;
